var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',_vm._b({class:{ 'btn-icon': _vm.isIconButton },attrs:{"aria-label":_vm.buttonLabel},on:{"click":function($event){return _vm.onToggle($event)}}},'gl-button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.buttonLabel))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }